/**
 * Инструменты DataHunter: единый список для шапки и подвала.
 *
 * Список жил копией в шапке и в подвале. Разъезд был бы тихим: новый
 * инструмент просто не появился бы в части мест, и заметить это можно
 * только глазами. Теперь он один, а тест сверяет с ним шапку.
 *
 * Порядок значим: он повторяет порядок карточек на главной, от самых
 * старых инструментов к новым.
 */
/**
 * Поле `card` — основа ключей перевода карточки на главной:
 * `<card>_card` и `<card>_card_desc` в разделе `dh_home`.
 *
 * Выведено в явный вид, а не получается отрезанием `nav_` от `label`:
 * такое вычисление работало бы ровно до первого инструмента, у которого
 * ключ меню и ключ карточки называются по-разному, и ломалось бы тихо —
 * на главной вместо названия появилось бы имя ключа.
 */
export const DH_TOOLS = [
  { href: '/app/json-editor', label: 'nav_json', card: 'json' },
  { href: '/app/online-markdown-editor', label: 'nav_markdown', card: 'markdown' },
  { href: '/app/qr-code-generator', label: 'nav_qr', card: 'qr' },
  { href: '/app/saga', label: 'nav_saga', card: 'saga' },
  { href: '/app/xnote', label: 'nav_xnote', card: 'xnote' },
  { href: '/app/pdf-editor', label: 'nav_pdf', card: 'pdf' },
  { href: '/app/video-editor', label: 'nav_video', card: 'video' },
  { href: '/app/flowtime', label: 'nav_flowtime', card: 'flowtime' },
  { href: '/app/file-transfer', label: 'nav_transfer', card: 'transfer' },
  { href: '/app/proxy-list', label: 'nav_proxy', card: 'proxy' },
  { href: '/app/proxy-checker', label: 'nav_proxy_check', card: 'proxy_check' },
  { href: '/app/breathing-exercise', label: 'nav_breathing', card: 'breathing' },
  { href: '/app/microphone-test', label: 'nav_mic', card: 'mic' },
  { href: '/app/datasets', label: 'nav_datasets', card: 'datasets' },
  { href: '/app/what-is-my-ip', label: 'nav_myip', card: 'myip' },
  { href: '/app/dns-lookup', label: 'nav_dns', card: 'dns' },
  { href: '/app/whois', label: 'nav_whois', card: 'whois' },
  { href: '/app/ssl-checker', label: 'nav_ssl', card: 'ssl' },
] as const;
